import { apiClient, getUserId } from "./authService";

interface PromoData {
  [key: string]: any;
}

export const getAllServices = async (unitId: string) => {
  if (!unitId) {
    throw new Error("unitId is required");
  }

  const res = await apiClient.get(`/services/unit/${unitId}`);
  return res.data; // Service[]
};

export const getAllServicesByBusiness = async (businessId: string) => {
  if (!businessId) {
    throw new Error("businessId is required");
  }

  const res = await apiClient.get(`/services/business/${businessId}`);
  return res.data; // Service[]
};

export const createService = async (branchData: PromoData): Promise<any> => {
  try {
    const response = await apiClient.post("/services/create", branchData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateService = async (
  id: string,
  branchData: PromoData
): Promise<any> => {
  try {
    const response = await apiClient.patch(`/services/update/${id}`, branchData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteService = async (id: string): Promise<any> => {
  try {
    const response = await apiClient.delete(`/services/delete/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const applyServicesToUnits = async (payload: {
  sourceUnitId: string;
  targetUnitIds?: string[];
  businessId?: string;
  skipIfNameExists?: boolean;
}): Promise<any> => {
  try {
    const response = await apiClient.post("/services/apply-to-units", payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};
